<script setup lang="ts">
import { computed } from 'vue'
import SiteLink from './SiteLink.vue'
import type { HeaderAction } from './types'

const props = defineProps<{
  actions?: HeaderAction[]
  mode: 'desktop' | 'small'
}>()

const styleOrder = {
  primary: 0,
  secondary: 1,
  tertiary: 2,
} as const

const visibleActions = computed(() => {
  return [...(props.actions ?? [])]
    .filter((action) => props.mode === 'desktop' ? action.showOnDesktop : action.showOnSmall)
    .sort((first, second) => styleOrder[first.style] - styleOrder[second.style])
    .slice(0, 3)
})

function actionClass(action: HeaderAction): string {
  if (action.style === 'secondary') return 'site-site-button-secondary'
  if (action.style === 'tertiary') return 'site-site-button-tertiary'

  return 'site-site-button'
}
</script>

<template>
  <div
    v-if="visibleActions.length"
    class="site-header-actions"
    :class="mode === 'desktop' ? 'site-header-actions--desktop' : 'site-header-actions--small'"
  >
    <SiteLink
      v-for="action in visibleActions"
      :key="action.style"
      :link="action.link"
      :class="actionClass(action)"
    >
      {{ action.link.label }}
    </SiteLink>
  </div>
</template>

<style scoped>
.site-header-actions--desktop {
  display: none;
}

.site-header-actions--small {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

@container site-renderer (min-width: 64rem) {
  .site-header-actions--desktop {
    display: flex;
    align-items: center;
    gap: 0.625rem;
  }

  .site-header-actions--small {
    display: none;
  }
}
</style>
